// extracted by mini-css-extract-plugin
module.exports = {"camp-G":"G_camp-G__8x0To"};